<script>
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import { baseProps } from '@/libs/utils/forms/baseProps.js'

export default {
  components: {
    Label
  },
  props: {
    ...baseProps,
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => [
        {id: 1, nome: 'option 1', disabled: false},
        {id: 2, nome: 'option 2', disabled: false},
        {id: 3, nome: 'option 2', disabled: true}
      ]
    },
    rulesInput: {
      type: String,
      default: ''
    },
    nameValidation: {
      type: String,
      default: null
    }
  },
  computed: {
    rules () {
      return !this.value.length ? 'required' : ''
    }
  },
  methods: {
    updateValues (option) {
      const newValue = [...this.value]
      const index = newValue.findIndex(id => id === option.id)
      index > -1 ? newValue.splice(index, 1) : newValue.push(option.id)
      this.$emit('input', newValue)
      if (!newValue.length) {
        this.$refs.validationProviderRef.errors = ['Campo obrigatório']
      } else {
        this.$refs.validationProviderRef.errors = []
      }
    }
  }
}

</script>

<template>
  <validation-provider ref="validationProviderRef" :rules="rules" v-slot="{ errors }" :name="nameValidation ? nameValidation : nomeAba + '/' + label" mode="lazy">
    <el-col :class="marginLeft ? 'ml-2' : ''">
      <Label :label="label" :obrigatorio="obrigatorio" :Indice="Indice" />
      <div v-for="(option, index) in options" class="flex-column gap-2" :key="index">
        <div :class="index > 0 ? 'mt-2' : ''">
          <el-checkbox
            :disabled="option.disabled"
            :checked="value.includes(option.id)"
            @change="() => updateValues(option)">
            {{ option.nome }}
          </el-checkbox>
        </div>
      </div>
      <span class="help erro" v-if="errors.length > 0">  {{ errors[0] }} </span>
    </el-col>
  </validation-provider>
</template>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.erro {
  font-size: small;
  color: $color-error;
  margin-top: 5px;
  display: block;
  white-space: pre;
}

.radio-group.erro {
  border: 1px solid $color-error;
  border-radius: 4px;
  border-color: $color-error;
  -webkit-box-shadow: inset 0 1px 2px #ff867c , 0 0 9px $color-error;
  box-shadow: inset 0 1px 2px #ff867c, 0 0 4px #ff867c;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/InputCheck/InputCheck.vue